import { Col, Row, Tag, theme } from "antd"
import TableCardColumnComponent from "./table-card-column.component";
import { LeadRes } from "../../../../../response/lead.response";

const TableCardViewComponent = ({ getRowClassName, leadList }: any) => {

    const { useToken } = theme;
    const { token } = useToken();

    return (
        <>
            <Row style={{
                background: '#E0EEF7',
                padding: 10,
                borderRadius: 4,
                color: '#343433',
                fontWeight: 500,
                marginBottom: 2
            }}>
                <Col span={8}>Name</Col>
                <Col span={8}>Requirement</Col>
                <Col span={8} style={{
                    textAlign: 'center'
                }}>Next action</Col>
            </Row>


            {leadList.map((lead: LeadRes) => {
                return <Row style={{
                    background: '#1AA30E0D',
                    borderRadius: 4,
                    color: '#343433',
                    fontWeight: 500,
                    marginBottom: 2
                }}>
                    <TableCardColumnComponent lead={lead}/>
                </Row>
            })}
        </>
    )
}

export default TableCardViewComponent